<template>
    <div id="lesson-content" v-html="content"></div>
</template>

<script>
import VimeoVideoMixin from '../../mixins/VimeoVideoMixin';

export default {
	name: 'ContentLesson',

	mixins: [ VimeoVideoMixin ],

	props: {
		lesson: {
			required: true,
		},
	},

	data() {
		return {
			vimeo_players: [],
			content: '',
		};
	},

	methods: {
		setupContent() {
			const lesson = JSON.parse(this.lesson);
			let { content, videos, media } = lesson;

			if (videos !== null && videos.length > 0 && media) {
				media.forEach((media) => {
					if (media.type === 'normal') {
						let media_element;
						const media_item = videos.find(video => video.id === media.media_id);
						const uuid = Math.floor(Math.random() * 999999);

						if (typeof media_item !== 'undefined') {
							if(media_item.source_type === 'file') {
								if (media_item.status === 'uploaded') {
									media_element = `<div id="vimeo-player-${uuid}${media_item.source_content_id}"></div>`;
								} else {
									media_element = `<div class="responsive-video embed-16-by-9"><div class="video-processing-wrapper tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"><div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center"><i class="fal fa-clock tw-text-gray-300 tw-mb-3"></i>${this.$t('membership.processing_video')}</div></div></div>`;
								}
							} else if (media_item.source_type === 'embedded') {
								if (media_item.source_content === null) {
									if (media_item.source_host === 'vimeo') {
										const sourceContentIdContainsQuestionMark = media_item.source_content_id.includes('?');
										media_element = `<iframe src="https://player.vimeo.com/video/${media_item.source_content_id}${sourceContentIdContainsQuestionMark ? '&' : '?'}color=33718a&title=0&byline=0&portrait=0" frameborder="0" allow="fullscreen" allowfullscreen></iframe>`;
									} else if (media_item.source_host === 'youtube') {
										media_element = `<iframe src="https://youtube.com/embed/${media_item.source_content_id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
									}
								} else {
									media_element = media_item.source_content;
								}
							}
	
							content = content.replace(`<span data-huddle-media-item="true" hidden="true">[media_id=${media_item.id}:pivot_id=${media.id}]</span>`, media_element);
	
							if (media_item.source_type === 'file' && media_item.status === 'uploaded') {
								this.$nextTick(() => {
									this.vimeo_players.push(
										this.initializeVimeoVideo(uuid, media_item.source_content_id)
									);
								});
							}
						}
					}
				});
			}

			this.content = content;
		},
	},

	mounted() {
		this.setupContent();
	},
};
</script>

<style lang="scss">
    #lesson-content {
        .video-processing-wrapper {
            background: #FAFAFA;

            i {
                @apply tw-text-5xl #{!important};

                @screen md {
                    @apply tw-text-6xl #{!important};
                }
            }
        }
    }
</style>